// src/data/portfolioData.js

export const getPortfolioData = () => ({
  herosection: {
    firstName: "Janakrishnamoorthy",
    lastName: "Rajasekaran",
    dateOfBirth: "26.09.2001",
    role: ["Web Developer", "React.js Developer", "SEO Analyst"],
    description: "Welcome to my corner of the web🌐! I'm Janakrishnamoorthy, a passionate freelance web developer in theni with a knack for crafting stunning digital experiences. From sleek and responsive designs to dynamic web applications, I bring your ideas to life with a blend of creativity and technical expertise.",
  },

  about: {
    summary: "A Freelance web developer and digital enthusiast based in Theni, specializing in crafting visually stunning websites, optimizing for search engines, and delivering compelling content to elevate your online presence.",
    skills: ["HTML", "CSS", "JavaScript", "React.js", "Git", "SEO"],
    languagesKnown: ["Tamil", "English", "Kannadam"],
  },

  education: [
    {
      institution: "ZKM Higher Secondary School",
      year: "2015 - 2016",
      qualification: "SSLC",  
      percentage: "81.2%"
    },
    {
      institution: "ZKM Higher Secondary School",
      year: "2017 - 2018",
      qualification: "HSC",
      percentage: "53.5%"
    },
    {
      institution: "Erode Sengunthar Engineering College",
      year: "2019 - 2023",
      qualification: "BE - Computer Science and Engineering",
      percentage: "8.89 CGPA"
    },
    // {
    //   institution: "Erode Sengunthar Engineering College",
    //   year: "2019 - 2023",
    //   qualification: "BE - Computer Science and Engineering",
    //   percentage: "8.89 CGPA"
    // }
  ],

  skills: [
    { name: "HTML", level: "95%" },
    { name: "CSS", level: "90%" },
    { name: "JavaScript", level: "89%" },
    { name: "React.js", level: "80%" },
    { name: "Photoshop", level: "80%" },
    { name: "Search Engine Optimization", level: "90%" },
    { name: "Content Creation", level: "75%" },
    { name: "Prompt Engineering", level: "96%" }
  ],

  experience: [
    {
      company: "Market Simplified Private Limited",
      duration: "November 2024 - Till Now",
      location: "Chennai",
      companyLogoURL: "https://vcard.janakrishnamoorthy.in/media/msf.png",
      role: "Software Engineer - Level 1",
      description:
        "I’m a Software Engineer – Level 1 at Market Simplified Pvt. Ltd., working on the Axis Mutual Fund web app using Next.js and React.js. I focus on developing key modules, enhancing UI/UX, and optimizing performance for a seamless user experience."
    },
    {
      company: "Nearlook Mart Private Limited",
      duration: "November 2023 - November 2024",
      location: "Theni",
      companyLogoURL: "https://vcard.janakrishnamoorthy.in/media/nearlook.png",
      role: "Junior Software Developer",
      description: "I worked as a Junior Software Developer at Nearlook Mart Pvt. Ltd., building and maintaining web applications using HTML, CSS, JavaScript, and ReactJS. I contributed to key features, improved UI/UX, optimized performance, and ensured scalable, high-quality code."
    },
        {
      company: "GR-Infotech",
      duration: "April 2023 - July 2023",
      location: "Chennai",
      companyLogoURL: "https://vcard.janakrishnamoorthy.in/media/grinfotech.png",
      role: "Junior Developer Trainee",
      description: "During my time at GR-Infotech, Chennai, I worked as a “Junior Developer Trainee” and actively participated in live projects. Through these experiences, I gained valuable skills in handling various types of projects and understanding the nature of each project."
    }

  ],
slides: [
  {
    src: "https://janakrishnamoorthy.in/Projects/1.png",
    link: "https://thebusinessforumofindia.org/TBF-App/login.php",
    title: "Business Referral Application",
    tech: ["HTML5", "CSS3", "Javascript", "PHP", "MySql"],
    description: "A platform to manage and track business referrals with user-friendly dashboards.",
  },
  {
    src: "https://janakrishnamoorthy.in/Projects/2.png",
    link: "https://www.vpspumpscorporation.com/admin/login",
    title: "E-Commerce Application",
    tech: ["HTML5", "CSS3", "Javascript", "PHP", "MySql"],
    description: "An e-commerce solution with product management, orders, and secure payments.",
  },
  {
    src: "https://janakrishnamoorthy.in/Projects/3.png",
    link: "https://rainbowtrainingacademy.com/",
    title: "Training Academy Website",
    tech: ["HTML5", "CSS3", "Javascript"],
    description: "A responsive website for showcasing trailer training courses, admissions, and academy details.",
  },
  {
    src: "https://janakrishnamoorthy.in/Projects/4.png",
    link: "https://k2businesses.com/",
    title: "Real Estate Management Application",
    tech: ["HTML5", "CSS3", "Javascript", "PHP", "MySql"],
    description: "A real estate portal for listing, buying, selling, and leasing properties.",
  },
  {
    src: "https://janakrishnamoorthy.in/Projects/5.png",
    link: "https://sripalanisakthinatyalaya.scriptingspider.com/login.php",
    title: "Student Management Application",
    tech: ["HTML5", "CSS3", "Javascript", "PHP", "MySql"],
    description: "An application for managing student records, classes, and attendance efficiently.",
  },
  {
    src: "https://janakrishnamoorthy.in/Projects/6.png",
    link: "https://magicalcrowninn.com/",
    title: "Resort Website",
    tech: ["HTML5", "CSS3", "Javascript"],
    description: "A resort website featuring rooms, amenities, booking, and customer inquiries.",
  },
  {
    src: "https://janakrishnamoorthy.in/Projects/7.png",
    link: "https://www.janakrishnamoorthy.in/",
    title: "Tax Invoice Application",
    tech: ["React.js", "Bootstrap", "Node.js", "MySql"],
    description: "A tax billing system to generate, manage, and track invoices digitally.",
  }
],


events: [
  {
    src: "https://janakrishnamoorthy.in/Event/1.png",
    title: "6 Days of Short Term Course",
    description: "Conducted a 6-day Short Term Course on Digital Marketing at Nadar Saraswathi College of Arts and Science, Theni. The program focused on SEO, Social Media, Google Ads, and Content Marketing. Students gained hands-on exposure to practical tools and techniques. The sessions also guided them towards freelancing and digital career opportunities.",
  },
  {
    src: "https://janakrishnamoorthy.in/Event/2.png",
    title: "Mega Visitors Day - BNI Connect",
    description: "Attended Mega Visitors Day organized by BNI Connect as a business visitor. Presented 'Scripting Spider' services to professional entrepreneurs and leaders. Engaged in meaningful discussions about business growth and collaborations. Built valuable connections within a wide business networking community.",
  },
  {
    src: "https://janakrishnamoorthy.in/Event/3.png",
    title: "VORTEX - Fest 2k25",
    description: "Invited as Chief Guest for VORTEX Fest 2k25 by the Department of Computer Science and Engineering, Erode Sengunthar Engineering College. As a 2019–2023 alumnus, I addressed students on career growth, freelancing, and entrepreneurship. Shared my journey as a Software Engineer and Founder of 'Scripting Spider.' Inspired students to innovate and embrace opportunities in the tech industry.",
  }
],



  keywords : [
    "janakrishnamoorthy",
    "freelancer in theni",
    "web developer in theni",
    "website development in theni",
    "content creator in theni",
    "web developer janakrishnamoorthy",
    "frontend developer in theni",
    "seo analyst in theni",
    "service engineer in theni",
    "data analyst in theni",
    "Social Media Management in theni",
    "data analyst in theni",
    "app developer in theni",
    "business developer in theni",
    "owner of scripting spider",
    "Er.Janakrishnamoorthy",
    "Digital Marketing in Theni"
  ],


services: [
  {
    title: "Web Design & Development",
    imgUrl: "https://vcard.janakrishnamoorthy.in/assets/img/services/1.jpg",
    link: "",
    description: "Professional Web Design & Development services in Theni and across Tamil Nadu. I create responsive, SEO-optimized, and high-performing websites tailored for businesses, startups, and professionals. From custom websites to eCommerce solutions, I deliver modern designs that attract customers and grow your online presence."
  },
  {
    title: "Graphics Designing",
    imgUrl: "https://vcard.janakrishnamoorthy.in/assets/img/services/2.jpg",
    link: "",
    description: "Creative Graphic Design services in Tamil Nadu, including Theni, Madurai, Coimbatore, and Chennai. I design professional logos, branding, posters, flyers, and social media creatives that enhance your brand identity and help your business stand out in both local and state-wide markets."
  },
  {
    title: "Search Engine Optimization",
    imgUrl: "https://vcard.janakrishnamoorthy.in/assets/img/services/3.jpg",
    link: "",
    description: "SEO services in Theni and throughout Tamil Nadu to boost your website’s visibility on Google. With keyword research, on-page SEO, content optimization, and link building, I help businesses improve their search rankings, attract organic traffic, and reach customers across Tamil Nadu."
  },
  {
    title: "Content Writing",
    imgUrl: "https://vcard.janakrishnamoorthy.in/assets/img/services/4.jpg",
    link: "",
    description: "Content Writing services in Theni and Tamil Nadu for websites, blogs, and digital platforms. I create SEO-friendly, engaging, and original content that builds authority and connects with your audience. From business blogs to product descriptions, I deliver words that boost your brand across the state."
  },
  {
    title: "Social Media Management",
    imgUrl: "https://vcard.janakrishnamoorthy.in/assets/img/services/5.jpg",
    link: "",
    description: "Expert Social Media Management services in Theni and all over Tamil Nadu. I manage Facebook, Instagram, LinkedIn, and more with creative content, ad campaigns, and growth strategies to increase followers, brand engagement, and sales for your business."
  },
  {
    title: "Mobile App Development",
    imgUrl: "https://vcard.janakrishnamoorthy.in/assets/img/services/6.jpg",
    link: "",
    description: "Custom Mobile App Development services in Tamil Nadu for Android and iOS platforms. I build user-friendly, fast, and scalable apps for eCommerce, service bookings, education, and more. Whether you’re in Theni, Chennai, Coimbatore, or anywhere in Tamil Nadu, I help transform your business with powerful mobile solutions."
  },
  {
    title: "Google My Business",
    imgUrl: "https://vcard.janakrishnamoorthy.in/assets/img/services/7.jpg",
    link: "",
    description: "Google My Business optimization services in Tamil Nadu to help local businesses rank higher on Google Maps and local search. From profile setup to keyword optimization and reviews management, I ensure your business gets more visibility and attracts customers statewide."
  },
  {
    title: "Digital Business Card (NFC)",
    imgUrl: "https://vcard.janakrishnamoorthy.in/assets/img/services/8.jpg",
    link: "",
    description: "Smart NFC Digital Business Card services in Theni and across Tamil Nadu. Share your contact details, website, and social media instantly with just a tap. Modern, eco-friendly, and customizable NFC business cards make networking professional and hassle-free for businesses and individuals."
  }
],


  contact: {
    email: "janakrishnamoorthyr@gmail.com",
    phone: "8883521093",
    whatsapp: "https://wa.me/918883521093",
    instagram: "https://www.instagram.com/itzzmekrj?igsh=bjRjdWo0dTRldWx3",
    linkedIn: "https://www.linkedin.com/in/janakrishnamoorthy-r-b64608212/",
    website: "https://janakrishnamoorthy.in/",
    address: "42/A Subramaniya Swamy Kovil North Street",
    city: "Bodinayakanur",
    district: "Theni",
    state: "Tamilnadu",
    Pincode: "625513"
  },
});
